import { useEffect, useState } from "react";

import { IconButton, Avatar } from "@mui/material";

import {
    useGetUserDisplayNameQuery,
    useGetUserPhotoQuery,
} from "services/graph.api";

export interface LoggedInUserButtonProps {
    onClick: (event: React.MouseEvent<HTMLElement>) => void;
}

export default function LoggedInUserButton(props: LoggedInUserButtonProps) {
    const { data: userPhoto } = useGetUserPhotoQuery(undefined);
    const { data: userDisplayName } = useGetUserDisplayNameQuery(undefined);

    const [inititals, setInitials] = useState<string>();

    useEffect(() => {
        if (userDisplayName) {
            const nameParts = userDisplayName.split(" ");

            setInitials(
                nameParts
                    .map((x: string) => x[0])
                    .join("")
                    .substring(0, 3),
            );
        }
    }, [userDisplayName]);

    return (
        <IconButton
            size="large"
            aria-label={userDisplayName}
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={props.onClick}
            color="inherit"
        >
            <Avatar
                src={userPhoto}
                alt={userDisplayName}
            >
                {inititals}
            </Avatar>
        </IconButton>
    );
}
